import { $gettext } from '@/assets/javascripts/lib/gettext';

const colors = [
    { name: $gettext('Schwarz'), hex: '#000000' },
    { name: $gettext('Grau'), hex: '#898f94' },
    { name: $gettext('Weiß'), hex: '#ffffff' },
    { name: $gettext('Gelb'), hex: '#ffbd33' },
    { name: $gettext('Orange'), hex: '#f26e00' },
    { name: $gettext('Braun'), hex: '#a85d45' },
    { name: $gettext('Rot'), hex: '#d60000' },
    { name: $gettext('Violett'), hex: '#af2d7b' },
    { name: $gettext('Lila'), hex: '#682c8b' },
    { name: $gettext('Blau'), hex: '#28497c' },
    { name: $gettext('Petrol'), hex: '#129c94' },
    { name: $gettext('Grün'), hex: '#008512' },
];

export { colors };
